<template>
  <footer class="grid-container w-full bottom-0 flex-none surface1 mt-16">
    <div class="flex flex-col gap-4 items-center py-8 lg:gap-10">
      <div class="w-full flex flex-col gap-6 md:flex-row">
        <!-- Logo and social media -->
        <div
          class="w-full flex flex-col justify-center sm:flex-row sm:justify-start sm:items-center sm:gap-4 md:flex-col md:items-start md:max-w-fit lg:gap-0"
        >
          <Logo class="w-[176px] h-auto mx-auto sm:m-0" name="grayscale" />
          <div class="">
            <p class="body-lg p-2 text-center sm:text-left">Síguenos en nuestras redes sociales:</p>
            <div class="flex gap-4 justify-center sm:justify-start">
              <a
                v-for="(social, key) in socials"
                :key="key"
                :href="social.url"
                target="_blank"
                rel="external noopener"
                class=" h-10 w-10 p-2"
              >
                <Icon class="fill-primary hover:fill-primary20" :name="social.icon" />
              </a>
            </div>
          </div>
        </div>
        <!-- Main footer navigation -->
        <div class="flex flex-col gap-2 lg:grow lg:flex-row lg:justify-around">
          <nav v-for="(nav, key) in navigation" :key="key" class="">
            <h2 class="text-chips p-2 text-center sm:text-left">{{ nav.header }}</h2>
            <div class="flex flex-col sm:flex-row sm:flex-wrap lg:flex-col lg:flex-nowrap">
              <a
                v-for="(link, link_key) in nav.links"
                  :key="link_key"
                  :href="link.route"
              >
                <Button
                  
                  class="btn-text-link lg:max-w-fit lg:text-left"
                >
                  {{ link.label }}
                </Button>
              </a>
            </div>
          </nav>
        </div>
        <!-- / End Main footer navigation -->
      </div>
      <div class="md:p-2">
        <div class="flex flex-col justify-center text-center sm:flex-row sm:flex-wrap md:gap-6">
          <Link :href="$route('terms-and-conditions')" class="btn-text-link"
            >Términos y condiciones</Link
          >
          <Link :href="$route('privacy-policy')" class="btn-text-link">Política de privacidad</Link>
          <Link :href="$route('contact')" class="btn-text-link">Contáctanos</Link>
        </div>
        <p class="w-full label-lg text-center pt-4">
          © 2022 - Bolsa de Trabajo
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Logo from '@/Components/Logo'
import LogoLPG from '@/Components/LogoLPG'
import Icon from '@/Components/Icon'

export default {
  name: 'TheFooter',
  components: { Logo, Icon, LogoLPG, Link },
  data() {
    return {
      socials: [
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/bolsadetrabajo.sv',
          icon: 'round-facebook',
        },
        {
          name: 'LinkedIn',
          url: 'https://www.linkedin.com/showcase/bolsa-de-trabajo-sv/',
          icon: 'linkedin',
        },
      ],
      navigation: [
        {
          header: 'Bolsa de Trabajo',
          links: [{ name: 'inicio', label: 'Inicio', route: this.$route('home') }],
        },
        {
          header: 'Postulantes',
          links: [
            { name: 'registrar', label: 'Registrate', route: this.$route('register') },
          ],
        },
      ],
    }
  },
}
</script>
